var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-progress-container"},[_c('ul',{staticClass:"step-progress-bar"},_vm._l((_vm.length),function(i){return _c('li',{key:i,class:_vm.isActive(i)})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }